import { render, staticRenderFns } from "./HospitalAssetManagementTerms.vue?vue&type=template&id=c60ba2a0&scoped=true"
import script from "./HospitalAssetManagementTerms.vue?vue&type=script&lang=js"
export * from "./HospitalAssetManagementTerms.vue?vue&type=script&lang=js"
import style0 from "./HospitalAssetManagementTerms.vue?vue&type=style&index=0&id=c60ba2a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60ba2a0",
  null
  
)

export default component.exports